import Colors from '#/styles/Colors'
import Palette from '#/styles/Palette'

const limit_basic_color = Palette.orange.self[500]

export const ChartBuilderColors = {
  export: {
    fill: Palette.green.self[200],
    stroke: Palette.green.self[200],
  },

  feedback: {
    danger: Colors.feedback.danger.color,
    error: Colors.feedback.error.color,
    info: Colors.feedback.info.color,
    neutral: Colors.feedback.neutral.color,
    success: Colors.feedback.success.color,
    warning: Colors.feedback.warning.color,
  },

  limits: {
    expected_dim: Palette.orange.dark[500],
    expected_pev: Palette.orange.dark[500],
    goal: limit_basic_color,
    limit: limit_basic_color,
    limit_1: limit_basic_color,
    limit_2: Palette.red.light[500],
    limit_validator_1: limit_basic_color,
    meals: limit_basic_color,
    objective: limit_basic_color,
  },

  plotBands: {
    intense: Colors.dtr.intense,
    mild_to_moderate_stress: Colors.thi.mild_to_moderate_stress.plotband,
    moderate_to_severe_stress: Colors.thi.moderate_to_severe_stress.plotband,
    moderated: Colors.dtr.moderated,
    normal: Colors.dtr.normal,
    severe_stress: Colors.thi.severe_stress.plotband,
    stress_zone: Colors.thi.stress_zone.plotband,
    thermal_comfort: Colors.thi.thermal_comfort.plotband,
    trough_empty: Colors.trough_level.trough_empty,
    trough_full: Colors.trough_level.trough_full,
    trough_low: Colors.trough_level.trough_low,
  },
  plotlines: {
    'arrival.arrival.any': '#9ACBB1',
    'batch.camera.feed_delivery': '#4caf50',
    /* LOTE */
    'batch.diet.assignment': '#4caf50',
    'batch.diet.feed': '#4caf50',
    'batch.diet.pushing': '#4caf50',
    'discard.death.any': '#ff8a65',
    /* MOVIMENTAÇÃO */
    'discard.departure.any': '#ff8a65',

    /* MANEJO */
    'handling.general.any': '#5081af',
    'handling.nutrition.any': '#5081af',
    'handling.reproduction.any': '#5081af',
    'handling.sanitary.any': '#5081af',
    'health.condition_confirmation.challenge': Colors.health.challenge.color,
    'health.condition_confirmation.critical': Colors.health.critical.color,
    'health.condition_confirmation.normal': Colors.health.normal.color,
    'health.condition_confirmation.observation': Colors.health.observation.color,
    'health.condition.challenge': Colors.health.challenge.color,
    'health.condition.critical': Colors.health.critical.color,
    /* SAÚDE */
    'health.condition.normal': Colors.health.normal.color,
    'health.condition.observation': Colors.health.observation.color,
    /* PROTOCOLOS SANITÁRIOS */
    'health.sanitary_protocol.canceled': Colors.status.canceled.color,
    'health.sanitary_protocol.single_dose_treatment': Colors.status.completed.color,
    'health.sanitary_protocol.treatment_end': Colors.status.completed.color,
    'health.sanitary_protocol.treatment_start': Colors.status.ongoing.color,
    'milk.batch.milking': '#00b8d4',
    /* LEITE */
    'milk.quality.sample': Palette.blue.production[400],
    /* REPRODUÇÃO */
    'reproduction.abortion.any': '#ff5354',
    'reproduction.apt_after_delivery.any': '#8bc34a',
    'reproduction.birth.algorithm': '#ce93d8',
    'reproduction.birth.user': '#ce93d8',
    'reproduction.dry.any': '#739abf',
    'reproduction.embryo_transfer.ftet': '#83cc8c',
    'reproduction.embryo_transfer.normal': '#83cc8c',
    'reproduction.empty.any': '#90aea4',

    'reproduction.gynecologic_exam_apt.any': '#8bc34a',
    'reproduction.gynecologic_exam_inapt.any': '#fbc02d',
    'reproduction.heat.algorithm': '#80deea',

    'reproduction.heifer.algorithm': '#d4479e',
    'reproduction.heifer.user': '#d4479e',
    /* PROTOCOLOS */
    'reproduction.implant_insertion.ftai': '#ff8a80',

    'reproduction.implant_insertion.ftet': '#ff8a80',
    'reproduction.implant_insertion.pg': '#ff8a80',
    'reproduction.implant_removal.ftai': '#ff8a80',

    'reproduction.implant_removal.ftet': '#ff8a80',
    'reproduction.implant_removal.pg': '#ff8a80',
    'reproduction.inapt_after_delivery.any': '#fbc02d',
    'reproduction.inconclusive_pregnancy.any': '#b47171',
    'reproduction.induced_lactation.any': '#41a781',
    'reproduction.inseminated.ftai': '#ff7043',

    'reproduction.inseminated.ftet': '#ff7043',
    'reproduction.inseminated.normal': '#9ccc65',
    'reproduction.inseminated.pg': '#ff7043',
    'reproduction.natural_breeding.normal': '#ffab91',
    'reproduction.negative_pregnancy.any': '#b8abbf',
    'reproduction.pregnant_pre_delivery.any': '#ba4383',
    'reproduction.pregnant.any': '#ce93d8',
    'reproduction.protocol.animal_removed': '#5F06A4',

    'reproduction.protocol.heat_observation_end': '#5F06A4',
    'reproduction.protocol.heat_observation_start': '#5F06A4',
    'reproduction.protocol.implant_insertion': '#5F06A4',

    'reproduction.protocol.implant_removal': '#5F06A4',
    'reproduction.protocol.sync_start': '#5F06A4',
    'reproduction.visual_heat.any': '#80deea',
    'reproduction.weaning.user': '#00b8d4',
    /* RUMINAÇÃO */
    // ruminação baixa
    'rumination_threshold.danger.any': '#388e3c',
    // queda ruminação
    'rumination_variation.decrease.any': '#388e3c',
    // aumento ruminação
    'rumination_variation.increase.any': '#388e3c',
  },
  series: {
    abortions: Palette.red.peach[400],
    accumulated: Palette.orange.deep[400],
    accumulated_percentage: Palette.black.self[100],
    activity: '#ff8a65',
    activity_peak_1: Palette.red.salmon[300],
    activity_peak_2: Palette.red.self[600],
    adult: Colors.animal.adult.backgroundColor,
    adult_average: Palette.black.self[100],
    animals: Colors.animal.adult.backgroundColor,
    average: '#458759',
    average_dim: Palette.blue.dark[400],
    average_localized: Palette.blue.production[500],
    awaiting_confirmation: Palette.gray.light[500],
    calvings: '#880e4f',
    cancellation: Palette.red.self[400],
    chronic: Palette.red.self[400],
    conception_rate: '#41B8D5',
    conceptions: '#59b852',
    cowconnect_accounts: Palette.blue.production[200],
    cross_sell: Palette.blue.light[500],
    crosssell_cowconnect: Palette.orange.dark[400],
    crosssell_monitoring: Palette.green.light[400],
    cured: Palette.green.self[300],
    cycled: Palette.blue.sky[500],
    delayed_reproduction: '#e57373',
    departures: Palette.orange.dark[400],
    discarded_animals: Palette.red.peach[400],
    discards: Palette.red.peach[400],
    downsell: Palette.orange.self[500],
    dryings: '#7b1fa2',
    empty: Colors.animal.primiparous.backgroundColor,
    expected_deliveries: '#f48fb1',
    expected_dryings: '#ce93d8',
    expected_rate: Palette.orange.self[500],
    gestational_loss_rate: Palette.red.peach[400],
    health_challenge: Colors.health.challenge.graph,
    health_critical: Colors.health.critical.graph,
    health_observation: Colors.health.observation.graph,
    healthy: Palette.green.self[500],
    heats: Colors.services,
    heifer: Colors.reproduction.heifer.backgroundColor,
    ideal_period: '#57a86f',
    input_tokens: Palette.blue.zinc[300],
    intake: Palette.yellow.self[700],
    interactions_count: Palette.green.nutrition[400],
    lead_time_average: Palette.gray.dark[800],
    leisure: '#5081af',
    losses: Palette.red.peach[400],
    meals: '#59b852',
    monitoring_accounts: Palette.blue.light[500],
    month_rate: Palette.blue.marine[400],
    moving_average_dim: Palette.gray.self[800],
    multiparous: Colors.animal.multiparous.backgroundColor,
    negative_pregnancies: Palette.red.peach[200],
    new_contracts: Palette.blue.production[200],
    new_infections: Palette.orange.self[400],
    normal_alerts: Palette.gray.dark[400],
    normal_heat: Colors.heatStrength[3],
    not_cycled: Palette.gray.dark[400],
    not_pregnant: Palette.red.peach[400],
    not_served: Palette.gray.dark[400],
    output_tokens: Palette.blue.production[600],
    panting: '#CA3278',
    panting_average: Palette.pink.dark[500],
    panting_percentage: Palette.pink.dark[300],
    pev: Colors.animal.primiparous.backgroundColor,
    pre_delivery: '#ba4383',
    pregnancy_rate: '#2D8ABA',
    pregnant: Palette.purple.light[700],
    primiparous: Colors.animal.primiparous.backgroundColor,
    push_up: Palette.orange.deep[600],
    rate: Palette.blue.self[300],
    return_alerts: Palette.blue.sky[500],
    rumination: '#b9f6ca',
    rumination_trend_line: '#212121',
    scc: Palette.yellow.health[400],
    served: Palette.blue.sky[700],
    service_rate: '#6CE5E8',
    services: Colors.services,
    six_month_rate: Palette.blue.self[500],
    spc: Palette.yellow.health[200],
    strong_heat: Colors.heatStrength[5],
    temperature_humidity_index: '#e57373',
    thi: '#e57373',
    total: Palette.black.self[100],
    total_collars: Palette.gray.dark[800],
    total_localized: Palette.blue.production[200],
    total_tokens: Palette.gray.self[800],
    twelve_month_rate: Palette.blue.self[700],
    upsell: Palette.blue.production[300],
    vwp_traditional: Colors.reproduction.emptyPostDelivery.backgroundColor,
    weak_heat: Colors.heatStrength[1],
    weight_gained: Palette.orange.deep[500],
  },
} as const
